import logo from './logo.svg';
import './App.css';
import Header from './Layout/Header/Header';
import AllRoute from './AllRoute/AllRoute';
import Footer from './Layout/Footer/Footer';
import ScrollButtons from './Components/ScrollButtons/ScrollButtons';

function App() {
  return (
    <>
      
      <Header />

      <AllRoute/>
      <Footer/>
      <ScrollButtons/>
    </>
  );
}

export default App;
